import { IModal } from 'customTypes';
import { Dispatch, SetStateAction, useState } from 'react';
import JobTypeALists from '../../pages/sm_setting/setting12/JobTypeALists';
import ListBoxInModal from '../../pages/sm_setting/setting12/ListBoxInModal';
import CountBoxInModal from '../../pages/sm_setting/setting12/CountBoxInModal';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { handleListClick, countSelectedAtFoldable } from '../../hooks/useJobType';
import useBackHistory from '../../hooks/useBackHistory';

const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5010;
  width: 100%;
  height: 100%;
  height: 100vh;
  height: 100dvh;
  background-color: rgba(0, 0, 0, 60%);
  backdrop-filter: blur(0.5rem);
  transition: all ease 0.8s;
  display: flex;
  justify-content: center;
  align-items: center;
  .centered-content {
    height: 100%;
  }
  > .cctvSettingsModal {
    position: relative;
    z-index: 6000;
    display: flex;
    flex-direction: column;
    height: 36rem;
    max-height: calc(100vh - 2rem);
    max-height: calc(100dvh - 2rem);
    width: 32rem;
    background-color: var(--board);
    border-radius: 0.5rem;
    overflow: hidden;
    user-select: none;
    @media screen and (max-width: 1024px) {
      width: calc(100vw - 2rem);
    }
    @media screen and (max-width: 767px) {
      width: 100%;
      height: 100vh;
      height: inherit;
      overflow-y: auto;
      border-radius: 0;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--text-secondary);
      background-color: var(--tonal);
      border-bottom: 1px solid var(--outline);
      padding: 0.5rem;
      > .titleName {
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0 0.5rem;
      }
      > .closeButton {
        border-radius: 0.5rem;
        margin: 0.25rem;
        padding: 0.25rem;
        display: flex;
        cursor: pointer;
        color: var(--text-disabled);
        &:hover {
          color: var(--text-tertiary);
          background-color: var(--tonal-deep);
          box-shadow: 0 0.25rem 0.75rem 0 rgba(0, 0, 0, 0.2);
        }
      }
    }
    .body {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      overflow-y: scroll;
      padding: 0.5rem 0;
      background-color: var(--tonal-light);
      scrollbar-gutter: stable both-edges;
    }
    .result {
      border-top: 1px solid var(--outline);
      display: flex;
      flex-wrap: wrap;
      overflow: auto;
      min-height: 6rem;
      background-color: var(--board);
    }
    .footer {
      display: flex;
      justify-content: flex-end;
      justify-content: space-between;
      background-color: var(--board);
      border-top: 1px solid var(--outline);
      padding: 0.5rem;
      padding-left: 1rem;
      > .button {
        display: flex;
        align-items: center;
        height: 2.5rem;
        min-width: 5.5rem;
        justify-content: center;
        border-radius: 0.25rem;
        font-size: 0.875rem;
        letter-spacing: normal;
        background-color: var(--tonal-deep);
        color: var(--text-tertiary);
        padding: 0 0.5rem;
        cursor: pointer;
        background-color: var(--primary);
        color: var(--text-reverse);
        &:active {
          background-color: var(--filled-blue-deep);
        }
        &.disabled {
          pointer-events: none;
          color: var(--text-disabled);
          background-color: var(--tonal-deep);
          background-color: var(--tonal);
        }
      }
    }
  }
  > .confirmModal {
    position: relative;
    z-index: 6000;
    display: flex;
    flex-direction: column;
    height: 10rem;
    max-height: calc(100vh - 2rem);
    max-height: calc(100dvh - 2rem);
    width: 24rem;
    background-color: var(--board);
    border-radius: 0.5rem;
    overflow: hidden;
    user-select: none;
    .title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 6rem;
      flex-shrink: 0;
      border-bottom: 1px solid var(--outline);
      .main {
        color: var(--text-tertiary);
      }
      .sub {
        font-weight: 600;
        color: var(--text-secondary);
      }
    }
    .buttons {
      flex-grow: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.5em;
      padding: 0.5rem 0.75rem;
      background-color: var(--tonal);
      .button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 3rem;
        height: 100%;
        width: calc(50% - 0.25rem);
        border-radius: 0.25rem;
        gap: 0.5rem;
        cursor: pointer;
        color: var(--text-tertiary);
        &:hover {
          background-color: var(--board);
          color: var(--text-secondary);
          box-shadow: 0 0.25rem 0.75rem 0 rgba(0, 0, 0, 0.05);
          &:active {
            background-color: var(--tonal-deep);
            color: var(--text-secondary);
            box-shadow: 0 0.25rem 0.75rem 0 rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }
`;

type Props = {
  openModal: any;
  setOpenModal: Dispatch<SetStateAction<any>>;
  title: string;
  type?: 'unit' | 'array' | 'group'; // 단일 - 배열 ['userId', 'userId2'] | 배열 - 문자 [['userId, userId2'], ['userId3']] | 그룹 - [{ label: '', value: '' }]
  selectedProps?: string[]; // 단일 - 적용된 값 문자열 ( 형식 : ['code1, code2...] ')
  setSelectedProps?: Dispatch<SetStateAction<string[]>>;
  selectGroup?: any[]; // 그룹 - ( 형식 : [{ label: '', value: '', ... }] )
  setSelectGroup?: Dispatch<SetStateAction<any[]>>;
  comparisonList: any; // 비교 리스트
  isMultiSelect?: boolean; // 복수선택 여부
  maxLength?: number; // 최대 수 - default: 100s
  flatList?: JobtypeList[]; // 2단계 없이 1단계 목록
};

const GroupChkModal = ({ openModal, setOpenModal, title, type, selectedProps, setSelectedProps, selectGroup, setSelectGroup, comparisonList, isMultiSelect = true, maxLength, flatList }: Props) => {
  const { t } = useTranslation();
  const currentSelect = type === 'unit' ? selectedProps : type === 'array' ? openModal.el.userId : selectGroup?.map((el: any) => el.userId || el.value);
  const [selected, setSelected] = useState<string[]>(currentSelect);

  // 모달 닫기 버튼 클릭 함수
  const onClickClose = () => {
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
  };

  const { onBackPrev } = useBackHistory({ isOpen: openModal.status, onPrev: onClickClose, pageName: 'groupChkModal' });

  // 저장 버튼 클릭 함수
  const onClickSave = () => {
    if (maxLength && selected.length > maxLength) {
      return toast.warn(t(`${maxLength}개까지 설정 가능합니다`));
    }

    if (type === 'unit') {
      setSelectedProps && setSelectedProps(selected);
    }
    if (type === 'group') {
      setSelectGroup &&
        setSelectGroup(
          selected
            .map((select: string) => ({
              userId: openModal?.findList.find((el: any) => el.userId === select)?.userId,
              label: openModal?.findList.find((el: any) => el.userId === select)?.userName,
              value: openModal?.findList.find((el: any) => el.userId === select)?.value,
              partName: openModal?.findList.find((el: any) => el.userId === select)?.partName,
              positionName: openModal?.findList.find((el: any) => el.userId === select)?.positionName,
            }))
            .filter((el: any) => el.userId)
        );
    }
    if (type === 'array') {
      openModal.state[openModal.index].userId = selected;
    }

    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
    return false;
  };

  return (
    <Root onClick={onBackPrev} role='presentation'>
      <div className='cctvSettingsModal' role='presentation' onClick={(event) => event.stopPropagation()}>
        <div className='header'>
          <div className='titleName'>{title}</div>
          <span
            className='material-symbols-rounded closeButton' //
            onClick={onBackPrev}
            role='presentation'
          >
            close
          </span>
        </div>

        {flatList ? (
          <>
            <div className='body'>
              {flatList.map((item) => (
                <div
                  key={item.key}
                  role='presentation'
                  onClick={() => {
                    if (isMultiSelect) {
                      handleListClick(item, setSelected, selected, true);
                      return;
                    }

                    if (selected.includes(item.key)) {
                      setSelected([]);
                      return;
                    }

                    setSelected([item.key]);
                  }}
                >
                  <ListBoxInModal data={item} isSelected={selected.includes(item.key)} />
                </div>
              ))}
            </div>
            <div className='footer'>
              <CountBoxInModal count={countSelectedAtFoldable(flatList, selected)} totalCount={flatList.length} />
              <button className='button' type='button' onClick={onClickSave}>
                {t('적용')}
              </button>
            </div>
          </>
        ) : (
          <JobTypeALists jobTypeLists={comparisonList} selected={selected} setSelected={setSelected} onClickSave={onClickSave} isMultiSelect={isMultiSelect} />
        )}
      </div>
    </Root>
  );
};

export default GroupChkModal;
